import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UsersService } from '../../services/users.service';
import { HttpService } from '../../services/http.service';
import { FunctionsService } from '../../services/functions.service';
import { Consultants } from '../../models/consultants.model';
import Swal from 'sweetalert2';
import { ConsultantsProduits } from 'src/app/models/consultantsProduits.model';
import { ConsultantsExpertises } from 'src/app/models/consultantsExpertises.model';
import { ConsultantsMissions } from 'src/app/models/consultantsMissions.model';
import { ConsultantsCountries } from '../../models/consultantsCountries.model';

@Component({
  selector: 'app-consultant-account',
  templateUrl: './consultant-account.component.html',
  styleUrls: ['./consultant-account.component.scss']
})
export class ConsultantAccountComponent implements OnInit {

  personalInfoForm: FormGroup = new FormGroup({});
  personalInfoIsLoading: boolean = false;
  consultants: Consultants = new Consultants([]);
  cvValue: any;
  cvFile: any;
  cvPath: any;
  
  produitsForm: FormGroup = new FormGroup({});
  produitList: any
  produitIsLoading: boolean = false;
  consultantProduitList: any;
  
  expertisesForm: FormGroup = new FormGroup({});
  expertiseList: any
  expertiseIsLoading: boolean = false;
  consultantExpertiseList: any;

  missionsForm: FormGroup = new FormGroup({});
  missionIsLoading: boolean = false;
  consultantMissionList: any;
  certificatValue: any;
  certificatFile: any;
  certificatPath: any;

  countriesForm: FormGroup = new FormGroup({});
  countryList: any[] = [];
  countryIsLoading: boolean = false;
  consultantCountryList: any;
  
  constructor(private router: Router, private formBuilder: FormBuilder, private usersService: UsersService, public functionsService: FunctionsService, private httpService: HttpService) {
    if (usersService.getUserType() != 'consultant') {
      this.router.navigate(['/not-found']);
    }
    this.consultants = this.usersService.getCurrentUser();
  }

  ngOnInit(): void {
    this.initPersonalInfoForm();
    
    this.initProduitForm();
    
    this.initExpertiseForm();
    
    this.initMissionForm();
    
    this.loadCountries();
    
    this.initCountryForm();
  }

  initPersonalInfoForm() {
    this.cvValue = this.consultants.getCvPath();
    this.cvPath = (this.consultants.getCvPath() != null) ? this.consultants.getCvPath() : '';
    this.personalInfoForm = this.formBuilder.group({
      gender: [this.consultants.getGender(), Validators.required],
      first_name: [this.consultants.getFirstName(), Validators.required],
      last_name: [this.consultants.getLastName(), Validators.required],
      email: [this.consultants.getEmail(), [Validators.required, Validators.email]],
      date_birth: [this.consultants.getDateBirth(), Validators.required],
      phone_1: [this.consultants.getPhone1(), Validators.required],
      phone_2: [(this.consultants.getPhone2() == null || this.consultants.getPhone2() == 'null') ? '' : this.consultants.getPhone2()],
      daily_fee: [(this.consultants.getDailyFee() == null || this.consultants.getDailyFee() == 'null') ? '' : this.consultants.getDailyFee(), Validators.required],
    });
  }

  onSubmitPersonalInfoForm(): any {
    if (this.cvValue == null && this.cvFile == null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez joindre votre CV.',
      })

      return false;
    }

    let formValue: any = this.personalInfoForm.value;
    
    formValue['cv_file'] = this.cvFile;

    this.personalInfoIsLoading = true;
    this.httpService.editConsultant(formValue).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentConsultant', JSON.stringify(data));
          this.personalInfoIsLoading = false;
          this.consultants = this.usersService.getCurrentUser();
          this.initPersonalInfoForm();
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Vos informations personnelles ont été mises à jour.',
          })
        }
      },
      (error) => {
        this.personalInfoIsLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  initProduitForm() {
    this.getConsultantsProduits();
    this.produitList = this.functionsService.getProduitsList();
    this.produitsForm = this.formBuilder.group({
      produit_id: ['', Validators.required],
    });
  }

  onSubmitProduitForm(): any {
    let formValue: any = this.produitsForm.value;

    this.produitIsLoading = true;

    this.httpService.addConsultantProduit(formValue, this.consultants.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentConsultant', JSON.stringify(data));
          this.produitIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Produit ajouté.',
          })
          this.consultants = this.usersService.getCurrentUser();
          this.initProduitForm();
          this.getConsultantsProduits();
        }
      },
      (error) => {
        this.produitIsLoading = false;
        if (error.error.message == 'PRODUIT_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ce produit a déjà été ajouté.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeProduit(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer ce produit ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeConsultantProduit(id, this.consultants.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentConsultant', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Produit supprimé.',
              });
              this.consultants = this.usersService.getCurrentUser();
              this.initProduitForm();
              this.getConsultantsProduits();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  initExpertiseForm() {
    this.getConsultantsExpertises();
    this.expertiseList = this.functionsService.getExpertiseList();
    this.expertisesForm = this.formBuilder.group({
      expertise_id: ['', Validators.required],
    });
  }

  onSubmitExpertiseForm(): any {
    let formValue: any = this.expertisesForm.value;

    this.expertiseIsLoading = true;

    this.httpService.addConsultantExpertise(formValue, this.consultants.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentConsultant', JSON.stringify(data));
          this.expertiseIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Expertise ajoutée.',
          })
          this.consultants = this.usersService.getCurrentUser();
          this.initExpertiseForm();
          this.getConsultantsExpertises();
        }
      },
      (error) => {
        this.expertiseIsLoading = false;
        if (error.error.message == 'EXPERTISE_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Cette expertise a déjà été ajoutée.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeExpertise(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer cette expertise ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeConsultantExpertise(id, this.consultants.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentConsultant', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Expertise supprimée.',
              });
              this.consultants = this.usersService.getCurrentUser();
              this.initExpertiseForm();
              this.getConsultantsExpertises();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  initMissionForm() {
    this.getConsultantsMissions();
    const consultantsMission: any = this.consultants.getConsultantsMissions();
    
    this.certificatValue = (this.consultants.getConsultantsMissions() != null) ? consultantsMission['certificat_path'] : null;
    this.certificatPath = (this.consultants.getConsultantsMissions() != null) ? consultantsMission['certificat_path'] : '';
    this.missionsForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  onSubmitMissionForm(): any {
    if (this.certificatValue == null && this.certificatFile == null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez joindre le certificat de la mission.',
      })

      return false;
    }

    let formValue: any = this.missionsForm.value;
    formValue['certificat'] = this.certificatFile;

    this.missionIsLoading = true;

    this.httpService.addConsultantMission(formValue, this.consultants.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentConsultant', JSON.stringify(data));
          this.missionIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Mission ajoutée.',
          })
          this.consultants = this.usersService.getCurrentUser();
          this.initMissionForm();
          this.getConsultantsMissions();
        }
      },
      (error) => {
        this.missionIsLoading = false;

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  removeMission(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer cette mission ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeConsultantMission(id, this.consultants.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentConsultant', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Mission supprimée.',
              });
              this.consultants = this.usersService.getCurrentUser();
              this.initMissionForm();
              this.getConsultantsMissions();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  initCountryForm() {
    this.getConsultantsCountries();
    this.countriesForm = this.formBuilder.group({
      country: ['', Validators.required],
    });
  }

  onSubmitCountryForm(): any {
    let formValue: any = this.countriesForm.value;

    this.countryIsLoading = true;

    this.httpService.addConsultantCountry(formValue, this.consultants.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentConsultant', JSON.stringify(data));
          this.countryIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Pays ajouté.',
          })
          this.consultants = this.usersService.getCurrentUser();
          this.initCountryForm();
          this.getConsultantsCountries();
        }
      },
      (error) => {
        this.countryIsLoading = false;
        if (error.error.message == 'COUNTRY_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ce pays a déjà été ajouté.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeCountry(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer ce pays ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeConsultantCountry(id, this.consultants.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentConsultant', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Pays supprimé.',
              });
              this.consultants = this.usersService.getCurrentUser();
              this.initCountryForm();
              this.getConsultantsCountries();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

  getConsultantsCountries() {
    const consultantsCountries: any = this.consultants.getConsultantsCountries();

    this.consultantCountryList = [];

    consultantsCountries.forEach((element: any) => {
      let consultantsCountries = new ConsultantsCountries(element);
      this.consultantCountryList.push(consultantsCountries);
    });
  }

  getConsultantsMissions() {
    const consultantsMissions: any = this.consultants.getConsultantsMissions();

    this.consultantMissionList = [];

    consultantsMissions.forEach((element: any) => {
      let consultantsMissions = new ConsultantsMissions(element);
      this.consultantMissionList.push(consultantsMissions);
    });
  }

  getConsultantsExpertises() {
    const consultantsExpertises: any = this.consultants.getConsultantsExpertises();

    this.consultantExpertiseList = [];

    consultantsExpertises.forEach((element: any) => {
      let consultantsExpertises = new ConsultantsExpertises(element);
      this.consultantExpertiseList.push(consultantsExpertises);
    });
  }

  getConsultantsProduits() {
    const consultantsProduits: any = this.consultants.getConsultantsProduits();

    this.consultantProduitList = [];

    consultantsProduits.forEach((element: any) => {
      let consultantsProduits = new ConsultantsProduits(element);
      this.consultantProduitList.push(consultantsProduits);
    });
  }

  loadCountries() {
    this.httpService.getCountries().subscribe(data => {
      const countries: any = data;
      let countryList: any[] = [];
      countries.find((item: { country: any; }) => {
        const country = item.country
        if (!countryList.includes(country)) {
          countryList.push(country)
        }
      });

      this.countryList = countryList.sort();
    })
  }

  async chooseNewCertificat() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner le certificat de la mission',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Certificat selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.certificatFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  async chooseNewCV() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner votre CV',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Cv selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.cvFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

}
